import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { CreateEventSessionDto } from '@/types/dtos/sessions/request/create-event-session.dto.ts';
import type { SessionDto } from '@/types/dtos/sessions/session.dto.ts';
import { GET_EVENT_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-event-sessions.ts';
import { GET_EVENT_FILTERED_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-filtered-event-sessions';

export const useCreateEventSessionMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newSession: CreateEventSessionDto) => {
      const token = await getToken();
      return createEventSession(newSession, token ?? '');
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_SESSIONS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FILTERED_SESSIONS_QUERY_KEY],
        }),
      ]);
    },
  });
};

const createEventSession = async (newSession: CreateEventSessionDto, token: string): Promise<SessionDto> => {
  const { eventId, session } = newSession;
  const url = `${import.meta.env.VITE_API_URL}/sessions/event/${eventId}`;
  return sendJSONRequest({ url, method: METHOD.POST, body: session, token });
};

export default useCreateEventSessionMutation;
